import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  theme?: any;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
}) => {
  const modules = {
    toolbar: [
      ['bold', 'italic'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['clean']
    ],
  };

  const formats = [
    'bold', 'italic', 'list'
  ];

  return (
    <div className="rich-text-editor-container">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        readOnly={disabled}
      />
      <style>{`
        .rich-text-editor-container .ql-editor {
          min-height: 120px;
          max-height: 300px;
          overflow-y: auto;
          font-size: 0.875rem;
          line-height: 1.5;
        }
        .rich-text-editor-container .ql-editor.ql-blank::before {
          white-space: normal;
          right: 15px;
          pointer-events: none;
          font-style: italic;
          color: #9CA3AF;
          opacity: 0.8;
        }
        .rich-text-editor-container .ql-toolbar {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          background-color: #f8f9fa;
        }
        .rich-text-editor-container .ql-container {
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      `}</style>
    </div>
  );
};
